
import {throwError as observableThrowError,  Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CarrierCategoryService {

  AppUrl = '';
  constructor(private readonly _http: HttpClient) {
    this.setAPIUrl();
  }

  setAPIUrl() {
    if (sessionStorage.getItem('BaseURL') != null && sessionStorage.getItem('BaseURL') != '') {
      this.AppUrl = sessionStorage.getItem('BaseURL') || '';
    }
  }

  GetCarrierCategoryByPage(TokenKey: any, filterModel: any): Observable<any> {
    this.setAPIUrl();
    const data = 'api/ActionItem/GetCarrierCategoryByPage';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(this.AppUrl + data, filterModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  CarrierCategoryAdminDelete(TokenKey: any, CarrierCatId: any): Observable<any> {
    this.setAPIUrl();
    const data = 'api/ActionItem/CarrierCategoryAdminDelete/' + CarrierCatId;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetCarrierCategorySearchById(TokenKey: any, CarrierCatId: any): Observable<any> {
    this.setAPIUrl();
    const data = 'api/ActionItem/GetCarrierCategorySearchById/' + CarrierCatId;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  CarrierCategoryAddUpdate(TokenKey: any, model: any): Observable<any> {
    this.setAPIUrl();
    const data = 'api/ActionItem/CarrierCategoryAddUpdate';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(this.AppUrl + data, model, httpOptions)
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    console.error(error.message || error);
    return observableThrowError(() => error.status);
  }
}
